import { SuiteManifest } from '../manifest';
import { biRoutes } from './routes';

export const biManifest: SuiteManifest = {
  id: 'bi',
  code: 'S9_BI',
  name: 'Business Intelligence',
  basePath: '/bi',
  icon: 'bar-chart',
  description: 'Dynamic squirrel query report builder, student learning analytics, website traffic attribution, and executive KPI dashboards.',
  requiredPermission: 'bi.read',
  allowedRoles: ['owner', 'admin', 'branch_head', 'accountant'],
  nav: [
    { label: 'Executive Dashboard', path: '/bi/executive', icon: 'bar-chart', group: 'Executive', status: 'live' },
    { label: 'Student Learning Analytics', path: '/bi/user-analytics', icon: 'activity', group: 'Analytics', status: 'live' },
    { label: 'Website & Ad Traffic', path: '/bi/traffic', icon: 'trending-up', group: 'Analytics', status: 'live' },
    { label: 'Dynamic SQL Builder', path: '/bi/report-builder', icon: 'file-text', group: 'Analytics', status: 'live' },
    { label: 'Admissions Funnel', path: '/bi/funnel', icon: 'trending-up', group: 'Marketing', status: 'live' },
    { label: 'Attendance Heatmaps', path: '/bi/attendance', icon: 'users', group: 'Operations', status: 'live' },
  ],
  routes: biRoutes,
};

export { biRoutes } from './routes';
export default biManifest;
